var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.143,
    height: 14.143,
    viewBox: "0 0 14.143 14.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.571,11.571A3.536,3.536,0,1,0,8.036,8.036,3.546,3.546,0,0,0,11.571,11.571Zm0,1.768c-2.342,0-7.071,1.193-7.071,3.536v1.768H18.643V16.875C18.643,14.532,13.914,13.339,11.571,13.339Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#fd5c3c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOrange);
export default __webpack_public_path__ + "static/media/user_orange.85b142c808ffe93a2fbd0b6ba6944403.svg";
export { ForwardRef as ReactComponent };